import mainRegistrationMixin from "@/mixins/registration/mainRegistrationMixin";
import isEmpty from "lodash/isEmpty";

export default {
    mixins: [mainRegistrationMixin],
    methods: {
        handleCaregiverSelect(selectedUuid) {
            let caregiverOption = this.caregiverOptions?.find(caregiverOption => caregiverOption.uuid === selectedUuid)
            if (!caregiverOption) {
                this.$notify({type: "error", message: this.$t('eventRegistration.start.invalidCaregiverToken')});
                return;
            }
            this.$store.commit('registration/setCaregiver', caregiverOption)
            this.$store.commit('registration/setCaregiverToken', selectedUuid)
        }
    },
    computed: {
        isCaregiver() {
            return this.$store.getters['registration/isCaregiver']
        },

        caregiver() {
            return this.$store.state.registration.caregiver
        },

        caregiverOptions() {
            return this.$store.state.registration.caregiverOptions
        },

        caregiverToken() {
            return this.$store.state.registration.caregiver?.uuid
        },

        personsHaveBeenCreatedAfterCaregiverSelection() {
            return !isEmpty(this.$store.state.registration.registrationData.persons)
        },
    },
}